import { FC, useRef } from 'react';
import { Col, Form } from 'antd';
import dayjs from 'dayjs';
import { isNotEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2FormRangePicker from '@/common/components/Form/V2FormRangePicker/V2FormRangePicker';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { getLeaseTermDuration } from './utils';

/**
 * @description 起止租期定制组件
 */
const LeaseTerm: FC<{
  propertyItem: any;
  form: any;
  disabled?: boolean;
  required?: boolean;
}> = ({
  propertyItem,
  form,
  disabled,
  required,
}) => {
  const label = propertyItem.anotherName || propertyItem.name || '';
  const value = Form.useWatch(propertyItem.identification, form);
  const duration = getLeaseTermDuration(value || []);
  const previousDateRangeRef = useRef<string[]>([]);
  const methods = useMethods({
    handleOpenChange(open) {
      if (open) {
        const previousValue = form.getFieldValue(propertyItem.identification);
        previousDateRangeRef.current = Array.isArray(previousValue) ? previousValue : [];
      }
    },
    getValueFromEvent(...[, dateString]) {
      if (Array.isArray(dateString) && dateString.length === 2 && dateString[0] && dateString[1] && dateString[0] === dateString[1]) {
        V2Message.warning('起止日期不能为同一天');
        return previousDateRangeRef.current.length ? previousDateRangeRef.current : null;
      }
      return Array.isArray(dateString) && dateString.filter(item => isNotEmpty(item)).length ? dateString : [];
    },
    getValueProps(currentValue) {
      return {
        value: currentValue === null
          ? null
          : Array.isArray(currentValue) && currentValue.filter(item => isNotEmpty(item)).length
            ? [dayjs(currentValue[0], 'YYYY-MM-DD'), dayjs(currentValue[1], 'YYYY-MM-DD')]
            : undefined
      };
    },
  });

  return <>
    <Col span={12}>
      <V2FormRangePicker
        label={label}
        name={propertyItem.identification}
        disabled={disabled}
        required={required}
        rules={[{ required, message: `请选择${label}` }]}
        formItemConfig={{
          getValueFromEvent: methods.getValueFromEvent,
          getValueProps: methods.getValueProps,
        }}
        config={{ onOpenChange: methods.handleOpenChange }}
      />
    </Col>
    <Col span={12}>
      <V2FormInput
        label='租期时长'
        placeholder={`选择${propertyItem.name}后自动计算`}
        disabled
        config={{ value: duration }}
      />
    </Col>
  </>;
};

export default LeaseTerm;
